@if (parentFormGroup.controls[controlName]) {
  <mat-form-field
    [formGroup]="parentFormGroup"
    appearance="fill"
    class="form-field w-full"
    floatLabel="always"
    hideRequiredMarker
    >
    @if (label) {
      <mat-label [class.error]="error" class="text-type-13">{{ label }}@if (isRequired) {
        <span>*&nbsp;</span>
        }:
      </mat-label>
    }
    @if (prefixIcon) {
      <mat-icon
        class="prefix"
        matPrefix
        svgIcon="{{prefixIcon}}"
        />
    }
    @if (suffixIcon) {
      <mat-icon
        class="suffix"
        matSuffix
        svgIcon="{{suffixIcon}}"
        />
    }
    @if (warning || suffixText) {
      <div class="suffix flex justify-end items-center" matSuffix>
        @if (error) {
          <mat-icon
            class="suffix"
            svgIcon="error"
            />
        }
        @if (!error && warning) {
          <mat-icon
            class="suffix"
            svgIcon="warning"
            />
        }
        @if (suffixText) {
          <div
            class="suffix uppercase"
            >
            {{ suffixText }}
          </div>
        }
      </div>
    }
    <input
      #input
      TimeInput
      [formControlName]="controlName"
      class="input number-input"
      matInput
      maxlength="5"
      placeholder="{{placeholder}}"
      type="text"
      >
  </mat-form-field>
}

